module.exports = "/virtual-football-league/img/amblems/left/logos/Rem.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Rem.png
// module id = 2120
// module chunks = 4